import React, { lazy } from 'react';
import { createBrowserRouter, Outlet } from 'react-router';

import PrivateRoute from './PrivateRoute';
import UnverifiedEmail from '../pages/Static/UnverifiedEmail';
import Login from '../pages/Login/Login';
import Home from '../pages/Home';
import LoginTeacher from '../pages/Login/LoginTeacher';
import Register from '../pages/Login/Register';
import RegisterTeacher from '../pages/Login/RegisterTeacher';

const Interactive = lazy(() => import('../pages/Practice/Interactive'));
const OrderConfirmation = lazy(() => import('../pages/Static/OrderConfirmation'));
const Exam = lazy(() => import('../pages/Practice/Exam/Exam'));
const Resource = lazy(() => import('../pages/Practice/Resource'));
const ResourcesDeprecated = lazy(() => import('../pages/Practice/ResourcesDeprecated'));
const Profile = lazy(() => import('../pages/User/Profile'));
const Teacher = lazy(() => import('../pages/Teacher/Teacher'));
const Ranking = lazy(() => import('../pages/Ranking/Ranking'));
const RouteNotFound = lazy(() => import('../pages/Static/RouteNotFound'));
const PlatformReports = lazy(() => import('../pages/Admin/PlatformReports'));
const QuestionReports = lazy(() => import('../pages/Admin/QuestionsReports'));
const Premium = lazy(() => import('../pages/Premium'));
const Subscriptions = lazy(() => import('../pages/Subscriptions'));
const Questions = lazy(() => import('../pages/Admin/Questions'));
const Exams = lazy(() => import('../pages/Admin/Exams'));
const Users = lazy(() => import('../pages/Admin/Users'));
const Simulation = lazy(() => import('../pages/Simulation/Simulation'));
const GenerateSimulation = lazy(() => import('../pages/Simulation/GenerateSimulation'));
const SimulationHistory = lazy(() => import('../pages/Simulation/History'));
const Tickets = lazy(() => import('../pages/Tickets'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Statistics = lazy(() => import('../pages/Statistics'));
const FAQ = lazy(() => import('../pages/Faq'));

// Create and export the router
export const router = createBrowserRouter([
	// Public routes
	{
		path: '/verify/email',
		element: <Login />
	},
	{
		path: '/login',
		element: <Login />
	},
	{
		path: '/login/profesor',
		element: <LoginTeacher />
	},
	{
		path: '/register',
		element: <Register />
	},
	{
		path: '/register/profesor',
		element: <RegisterTeacher />
	},
	{
		path: '/reset-password',
		element: <Login />
	},
	{
		path: '/unverifiedEmail/:email',
		element: <UnverifiedEmail />
	},
	{
		path: '/change-password',
		element: <Login />
	},

	// Protected routes
	{
		element: <PrivateRoute />, // Ensure authentication first
		children: [
			{
				path: '/',
				element: <Home />, // Home acts as layout
				children: [
					{ index: true, element: <Dashboard /> },
					{ path: 'statistici', element: <Statistics /> },
					{ path: 'profil', element: <Profile /> },
					{ path: 'profesor', element: <Teacher /> },
					{ path: 'profil/intrebari-frecvente', element: <FAQ /> },
					{ path: 'profil/premium', element: <Premium /> },
					{ path: 'profil/premium/abonament', element: <Subscriptions /> },
					{ path: ':subject/mod-interactiv', element: <Interactive /> },
					{ path: ':subject/test', element: <Exam /> },

					{ path: 'romana/materie', element: <Resource /> },
					{ path: 'istorie/materie', element: <Resource /> },
					{ path: 'engleza/materie', element: <Resource /> },

					{ path: 'civica/materie', element: <ResourcesDeprecated /> },
					{ path: 'legislatie/materie', element: <ResourcesDeprecated /> },
					{ path: 'tco/materie', element: <ResourcesDeprecated /> },
					{ path: 'logica/materie', element: <ResourcesDeprecated /> },

					{ path: ':subject/materie/admin', element: <Resource /> },

					{ path: 'simulare', element: <Simulation /> },
					{ path: 'simulare/start', element: <GenerateSimulation /> },
					{ path: 'simulare/istoric', element: <SimulationHistory /> },
					{ path: 'clasament/rezultate-tara', element: <Ranking /> },
					{ path: 'comanda/confirmata', element: <OrderConfirmation /> },
					{ path: 'tichete', element: <Tickets /> },
					{ path: 'admin/users', element: <Users /> },
					{ path: 'admin/raportari/grile', element: <QuestionReports /> },
					{ path: 'admin/raportari/platforma', element: <PlatformReports /> },
					{ path: 'admin/grile', element: <Questions /> },
					{ path: 'admin/exams', element: <Exams /> },
					{ path: '*', element: <RouteNotFound /> }
				]
			}
		]
	}
]);
